import { paramsSerializerRepeat } from '../utils/url'

export const buildGpsWaypointsParameter = gpsInfo => {
  return (gpsInfo?.query_path?.waypoints ?? [])
    .map(waypoint => {
      const [lng, lat] = waypoint.split(',')
      return `${lat},${lng}`
    })
    .join(';')
}

export const extractGpsQueryParameters = gpsInfo =>
  (gpsInfo?.query_params ?? []).reduce(
    (acc, curr) => ({
      ...acc,
      [curr.field]: curr.value
    }),
    {}
  )

export const buildGpsQueryParameters = gpsInfo => {
  return paramsSerializerRepeat(extractGpsQueryParameters(gpsInfo))
}

const buildGpsLink = (provider, waypoints, params) => `mappy://fr.mappy.com/gps/${provider}/${waypoints}?${params}`

export const getGpsLink = gpsInfo => {
  const provider = gpsInfo?.query_path?.gps_provider
  const waypoints = buildGpsWaypointsParameter(gpsInfo)

  if (!provider || !waypoints) return null

  const params = buildGpsQueryParameters(gpsInfo)

  return buildGpsLink(provider, waypoints, params)
}
